export default "__VITE_ASSET__010ea1f8__"